import React, { useContext, useEffect, useState } from "react";
import { Redirect, Route } from 'react-router-dom';
import { AllContextData } from "../App";

const PrivateRoute = ({ children, ...rest }) => {
  const loggedInfo =  JSON.parse(sessionStorage.getItem('loggedInUser'));

  return (
    <div>
      <Route
        {...rest}
        render={({ location }) =>
        // loggedInUser && loggedInUser.message === "success" ? (
          loggedInfo && loggedInfo.message === "success" ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/admin/login",
                state: { from: location },
              }}
            />
          )
        }
      />
    </div>
  );
};

export default PrivateRoute;